import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import HotResources from '../components/HotResources';

function Home() {
  return (
    <div className="home">
      <Header />
      <main className="main-content">
        <div className="container">
          <HotResources />
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Home;